import React, { useId } from 'react'

export const IaAvatarDark: React.FC<{ className?: string }> = ({
  className = '',
}) => {
  const id = useId()

  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id={`mask0_${id}`}
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="60"
        height="60"
      >
        <circle cx="30" cy="30" r="30" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#mask0_${id})`}>
        <circle cx="30" cy="30" r="30" fill="#4D5154" />
        <path
          d="M20.4549 36.8181H42.2731V37.7674C42.2731 43.9651 46.0568 49.5347 51.8185 51.8181L42.2731 59.9999H32.7276H20.4549L6.13672 49.7727L9.31958 49.3864C15.6753 48.6151 20.4549 43.2204 20.4549 36.8181Z"
          fill="#D6C3AF"
        />
        <path
          d="M26.4265 36.8181H36.9594V40.2572C36.9594 43.0144 38.4777 45.5476 40.9093 46.8474V46.8474V46.8474C35.7294 50.6814 28.7496 51.0158 23.227 47.6945L21.8184 46.8474V46.8474C24.6262 45.5609 26.4265 42.7557 26.4265 39.6672V36.8181Z"
          fill="#B9A38D"
        />
        <path
          d="M25.9082 36.8181H36.8173V37.9216C36.8173 40.3074 35.2668 42.4163 32.9897 43.1279V43.1279C31.9303 43.4589 30.7952 43.4589 29.7358 43.1279V43.1279C27.4587 42.4163 25.9082 40.3074 25.9082 37.9216V36.8181Z"
          fill="#9B8167"
        />
        <path
          d="M25.9082 36.8181H36.8173V36.8181C36.8173 38.5971 35.5502 40.1239 33.8017 40.4517L32.368 40.7205C31.7036 40.8451 31.0219 40.8451 30.3575 40.7205L28.9238 40.4517C27.1753 40.1239 25.9082 38.5971 25.9082 36.8181V36.8181Z"
          fill="#6D6155"
        />
        <path
          d="M15.8055 12.4462C17.836 6.86237 22.7164 2.80488 28.5771 1.82809L28.7368 1.80147C30.4759 1.51163 32.2517 1.52008 33.9879 1.82648C39.5253 2.80366 44.1017 6.69814 45.952 12.0079L46.8759 14.659C47.8859 18.9236 47.9335 23.3596 47.0153 27.645L46.3645 30.6817L46.0379 34.928C45.8174 37.7939 47.1121 40.5663 49.4511 42.237C50.1169 42.7126 50.8501 43.086 51.6264 43.3447L54.2229 44.2103C54.4371 44.2817 54.6615 44.3181 54.8873 44.3181H55.1175C55.1908 44.3181 55.2636 44.3063 55.3331 44.2831C55.9547 44.0759 55.9547 43.1966 55.3331 42.9894C55.2636 42.9662 55.1908 42.9544 55.1175 42.9544H54.5463H53.908C53.8972 42.9544 53.8938 42.9398 53.9035 42.935L54.3657 42.7038C54.8808 42.4463 55.5028 42.5473 55.91 42.9544L56.1097 43.1541C56.4184 43.4628 56.5918 43.8815 56.5918 44.3181L54.4004 48.7009C54.1214 49.2589 53.4051 49.428 52.906 49.0537L48.41 45.6817L52.5404 49.222C52.9111 49.5398 52.9981 50.079 52.7461 50.4973L51.8191 52.0363L42.3455 47.9626C38.1647 46.1649 35.4554 42.0508 35.4554 37.4999H26.5918C27.3813 41.842 24.9502 46.1269 20.8178 47.6765L8.86452 52.159L5.45543 48.409L7.50089 46.3635C6.61574 46.8061 5.89801 47.5238 5.45543 48.409L4.85614 48.7086C4.5266 48.8734 4.14548 48.6076 4.18617 48.2415L4.46371 45.7436C4.62771 44.2676 6.05543 43.2749 7.49613 43.6351C7.49737 43.6354 7.49737 43.6371 7.49613 43.6374L6.60164 43.8611C5.79713 44.0622 5.51962 45.0641 6.106 45.6505C6.12601 45.6705 6.15315 45.6817 6.18144 45.6817H6.2193C6.61038 45.6817 6.99271 45.5659 7.31811 45.349L10.91 42.9544C13.4658 41.2506 15.0009 38.3822 15.0009 35.3105V31.8007C15.0009 31.0556 14.948 30.3115 14.8426 29.574L14.5734 27.689C13.9541 23.354 14.0988 18.944 15.0009 14.659L15.8055 12.4462Z"
          fill="#1C1C1C"
        />
        <path
          d="M18.7837 16.34C18.3588 9.32868 23.9303 3.40918 30.9545 3.40918C37.9787 3.40918 43.5503 9.32867 43.1254 16.34L42.6389 24.367C42.5767 25.3932 42.4271 26.4123 42.1916 27.4131L41.691 29.5407C40.531 34.4705 36.8435 38.4154 32.003 39.9047C31.3198 40.115 30.5892 40.115 29.9061 39.9047C25.0656 38.4154 21.3781 34.4705 20.2181 29.5407L19.7175 27.4131C19.482 26.4123 19.3324 25.3932 19.2702 24.367L18.7837 16.34Z"
          fill={`url(#paint0_linear_${id})`}
        />
        <path
          d="M27.3971 32.9746C27.3456 32.8717 27.4327 32.7538 27.5462 32.7727L28.1724 32.8771C30.2828 33.2289 32.4395 33.1941 34.5375 32.7745V32.7745C34.6335 32.7553 34.7096 32.8549 34.6658 32.9425L34.6053 33.0635C34.2687 33.7368 33.7622 34.3106 33.1359 34.7281L32.8971 34.8873C32.3423 35.2572 31.6903 35.4546 31.0234 35.4546V35.4546C30.3566 35.4546 29.7046 35.2572 29.1497 34.8873L28.911 34.7281C28.2847 34.3106 27.7782 33.7368 27.4415 33.0635L27.3971 32.9746Z"
          fill="#8E4D50"
        />
        <path
          d="M29.8633 30.4471C29.8633 30.4294 29.8817 30.4176 29.8978 30.425L30.7558 30.8183V30.8183C31.0455 30.8183 31.3314 30.753 31.5924 30.6273L32.0102 30.426C32.0264 30.4182 32.0451 30.43 32.0451 30.4479V30.4479C32.0451 30.6753 31.9181 30.8838 31.7159 30.988L31.4776 31.1109C31.3292 31.1874 31.1646 31.2274 30.9975 31.2274H30.9108C30.7438 31.2274 30.5792 31.1874 30.4308 31.1109L30.1931 30.9884C29.9906 30.8839 29.8633 30.6751 29.8633 30.4471V30.4471Z"
          fill="#6D6155"
        />
        <path
          d="M28.0549 21.5672C28.0705 21.0879 27.7522 20.6652 27.2878 20.5483L27.0145 20.4795C25.5842 20.1195 24.1019 19.9961 22.6264 20.1143L22.2943 20.1409C21.8229 20.1786 21.4446 20.5514 21.4007 21.0214C23.6364 20.6652 25.9192 20.8525 28.0549 21.5672Z"
          fill="#1C1C1C"
        />
        <path
          d="M23.0742 26.8848C23.2976 27.151 23.5979 27.3414 23.9339 27.43L24.1531 27.4877C24.3521 27.5401 24.5572 27.5667 24.763 27.5667H25.6544C25.8632 27.5667 26.0712 27.5416 26.2739 27.4921L26.5598 27.4222C26.9012 27.3388 27.2082 27.1509 27.4379 26.8848L26.6836 27.0949C26.2092 27.227 25.719 27.2939 25.2266 27.2939C24.6906 27.2939 24.1576 27.2146 23.6449 27.0585L23.0742 26.8848Z"
          fill="#1D71BB"
        />
        <ellipse
          cx="25.256"
          cy="25.1121"
          rx="2.18182"
          ry="2.04545"
          fill="#0D3252"
        />
        <ellipse
          cx="24.8191"
          cy="24.2726"
          rx="0.727273"
          ry="0.681818"
          fill="#D6C3AF"
        />
        <path
          d="M21.3281 22.6908L22.5366 22.3585C23.1788 22.1819 23.8502 22.1376 24.51 22.2283L25.2956 22.3363C26.8472 22.5497 28.1052 23.7006 28.4553 25.2273L26.419 23.2908L24.9645 23.0454L24.2372 23.2908L22.7827 23.8908L21.3281 22.6908Z"
          fill="#94ACC3"
        />
        <path
          d="M20.4551 23.8636H21.1824L21.9096 23.1818V22.5L22.6369 23.1818L23.4329 22.8087C23.8666 22.6054 24.3397 22.5 24.8187 22.5C25.2977 22.5 25.7708 22.6054 26.2045 22.8087L26.5584 22.9746C26.8513 23.1119 27.1208 23.2945 27.3568 23.5158C27.6025 23.7461 27.8087 24.0152 27.9672 24.3124L28.4551 25.2273V25.9091L27.9672 24.9942C27.8087 24.6971 27.6025 24.4279 27.3568 24.1976C27.1208 23.9763 26.8513 23.7937 26.5584 23.6564L26.0205 23.4043C25.708 23.2578 25.3671 23.1818 25.0219 23.1818C24.4241 23.1818 23.8487 23.4093 23.4126 23.8182L23.3642 23.8636C22.9002 24.2986 22.6369 24.9063 22.6369 25.5424V25.9091L21.9096 25.2273L20.4551 23.8636Z"
          fill="#1C1C1C"
        />
        <path
          d="M34.1841 21.6768C34.1688 21.1973 34.4867 20.7728 34.9509 20.6529L35.177 20.5945C36.5843 20.2311 38.0443 20.1064 39.4962 20.2257L39.7782 20.2489C40.2495 20.2876 40.6261 20.6606 40.6689 21.131C38.4918 20.7751 36.2639 20.9626 34.1841 21.6768Z"
          fill="#1C1C1C"
        />
        <path
          d="M39.0391 26.8853C38.8215 27.1514 38.5261 27.3426 38.1943 27.4323L37.9906 27.4874C37.7947 27.5403 37.5926 27.5671 37.3897 27.5671H36.528C36.3223 27.5671 36.1174 27.5418 35.9178 27.4918L35.6491 27.4244C35.312 27.3399 35.0102 27.1513 34.7865 26.8853L35.5228 27.0957C35.9842 27.2275 36.4617 27.2944 36.9416 27.2944C37.4637 27.2944 37.9828 27.2152 38.4812 27.0596L39.0391 26.8853Z"
          fill="#1D71BB"
        />
        <ellipse
          cx="2.1263"
          cy="2.04545"
          rx="2.1263"
          ry="2.04545"
          transform="matrix(-1 0 0 1 39.0391 23.0667)"
          fill="#0D3252"
        />
        <ellipse
          cx="0.708766"
          cy="0.681818"
          rx="0.708766"
          ry="0.681818"
          transform="matrix(-1 0 0 1 37.1641 23.7009)"
          fill="#D6C3AF"
        />
        <path
          d="M40.5595 22.5736L39.4091 22.2967C38.7456 22.137 38.0559 22.1234 37.3878 22.2567L36.847 22.3645C35.2489 22.6834 34.021 23.9619 33.7674 25.5713L35.639 23.4498L37.0406 23.1223L37.7624 23.3428L39.2121 23.8978L40.5595 22.5736Z"
          fill="#94ACC3"
        />
        <path
          d="M41.5898 23.9737H40.8811L40.1723 23.2919V22.6101L39.4635 23.2919L38.6847 22.9173C38.2643 22.7151 37.8038 22.6101 37.3372 22.6101C36.8707 22.6101 36.4102 22.7151 35.9898 22.9173L35.6487 23.0814C35.3587 23.2209 35.0928 23.4056 34.8609 23.6287C34.6233 23.8572 34.4246 24.1229 34.2726 24.4154L33.7934 25.3374V26.0192L34.2726 25.0972C34.4246 24.8047 34.6233 24.539 34.8609 24.3105C35.0928 24.0874 35.3587 23.9027 35.6487 23.7632L36.1668 23.514C36.4707 23.3678 36.8036 23.2919 37.1407 23.2919C37.7216 23.2919 38.2798 23.5169 38.6984 23.9195L38.7548 23.9737C39.2076 24.4094 39.4635 25.0107 39.4635 25.639V26.0192L40.1723 25.3374L41.5898 23.9737Z"
          fill="#1C1C1C"
        />
        <path
          d="M18.6828 14.7964C18.9483 12.5399 19.8784 10.4132 21.3551 8.68645V8.68645C22.9599 6.81 25.1276 5.50192 27.5357 4.95692L28.4168 4.75753C30.3561 4.31861 32.3691 4.31861 34.3085 4.75753L35.1269 4.94275C37.5676 5.49514 39.746 6.86572 41.3004 8.82694V8.82694C42.3868 10.1977 43.1296 11.8084 43.4667 13.5246L43.6322 14.3674C44.0823 16.6586 43.9726 19.0246 43.3124 21.2642L42.1013 25.373V25.373C42.6491 21.0597 41.5444 16.6989 39.0091 13.1667L37.3913 10.9129L30.9949 16.7771C29.8469 17.8296 28.3579 18.433 26.8009 18.4767V18.4767C23.1692 18.5785 20.3322 21.6479 20.516 25.2764L20.624 27.409L18.8428 19.1467C18.5551 17.8118 18.4896 16.4385 18.6492 15.0822L18.6828 14.7964Z"
          fill="#9B8167"
        />
        <path
          d="M18.0992 16.8039C17.698 13.09 19.2219 9.42862 22.1396 7.09613V7.09613C23.3935 6.09373 24.8529 5.37994 26.414 5.00556L27.5716 4.72792C30.0646 4.13002 32.6637 4.13002 35.1567 4.72792L36.183 4.97405C37.8306 5.36919 39.3708 6.12253 40.6942 7.18049V7.18049C43.1515 9.1449 44.6995 12.028 44.9795 15.1614L44.9872 15.2471C45.1744 17.3431 44.7946 19.4509 43.8873 21.3497L41.796 25.7264V25.7264C43.0573 21.9002 42.3676 17.6989 39.9492 14.4766L37.2206 10.8411L30.915 15.882C29.7735 16.7945 28.3978 17.3665 26.9458 17.5324V17.5324C22.5646 18.0327 19.478 22.0754 20.1496 26.4336L20.2369 27.0002L18.1505 17.2786L18.0992 16.8039Z"
          fill="#1C1C1C"
        />
        <path
          d="M13.3906 50.4545L20.4541 47.7954L27.9541 58.6667L27.9541 59.9999L20.4541 59.9999L19.0905 59.3181L16.2406 57.195L13.3906 50.4545Z"
          fill="#383774"
        />
        <path
          d="M48.3385 50.5229L41.4438 47.5229L35.333 58.0001V58.0001C32.7502 58.8611 29.9459 58.7787 27.4182 57.7676L24.6663 56.6668L27.333 60.0001L32.727 60.0001L41.5906 60.0001L45.333 56.6667L48.3385 50.5229Z"
          fill="#383774"
        />
      </g>
      <defs>
        <linearGradient
          id={`paint0_linear_${id}`}
          x1="30.9545"
          y1="3.40918"
          x2="30.9545"
          y2="40.2274"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D71BB" />
          <stop offset="0.18" stopColor="#D6C3AF" />
        </linearGradient>
      </defs>
    </svg>
  )
}
